<template>
  <!-- 外侧 -->
  <div class="login">
    <div class="form-login">
      <!-- log -->
      <div class="form-login-log">
        <img src="../../assets/image/login/login-logo.png" />
      </div>
      <!-- 登录 -->
      <div class="form-login-center">
        <div class="form-login-mask">
          <img src="../../assets/image/login/MASK.png" />
        </div>
        <div class="form-login-content">
          <div class="form-login-top-bgc">
            <img src="../../assets/image/login/top-bgc.png" />
          </div>
          <!-- 账号登录、微信登录 -->
          <div class="class-login">
            <div class="button-list" v-for="(item, index) in buttonList"
              :class="buttonIndex === index ? 'button-active' : ''" @click="tableswitch(index)">
              {{ item }}
            </div>
          </div>
          <!-- 账号登录 -->
          <div v-show="buttonIndex == 0" class="account">
            <div class="phone-password">
              <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                class="demo-ruleForm" label-position="top">
                <el-form-item label="手机号" prop="username">
                  <el-input type="text" v-model="ruleForm.username" autocomplete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" class="add-password">
                  <el-input type="password" v-model="ruleForm.password" autocomplete="off" clearable
                    show-password></el-input>
                </el-form-item>
                <div class="remember-box">
                  <el-checkbox v-model="checked">记住我</el-checkbox>
                  <div @click="getforgetPwd">忘记密码</div>
                </div>
                <div class="submit">
                  <el-button @click="submitForm('ruleForm')" style="background: #484c7f; color: #fff; width: 315px;"
                    v-prevent="3000">登录</el-button>
                </div>
              </el-form>
              <!-- 注册 -->
              <div class="registered" @click="getRegistered">没有账号去注册</div>
              <!-- 底部背景图 -->
              <div class="buttom-img"><img src="../../assets/image/login/buttom-bgc.png"></div>
            </div>
          </div>
          <!-- 微信登录 -->
          <div v-show="buttonIndex == 1" class="wx-login">
            <div id="qrcode"> </div>
            <!-- <div class="hashCode">
              <img src="../../assets/image/login/hashCode.png">
            </div>
            <div class="hashCode-text">
              <div>使用微信扫一扫登录</div>
              <div style="padding-top: 5px;">"共识云"</div>
              
              <div class="buttom-img"><img
                  src="../../assets/image/login/buttom-bgc.png"
                ></div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="form-login-text">
        Copyright 2013 - 2020 凯斯通. All rights reserved
        备案号：京ICP备2021013735号-1
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'login',
  data() {
    //手机
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    }
    //密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      buttonIndex: 0,
      buttonList: ['账号登录', '微信登录'],
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ validator: validatePass, trigger: 'blur' }],
        password: [{ validator: validatePass2, trigger: 'blur' }]
      },
      checked: true,
      //项目分享
      Sharing: {
        teamId: '',
        projectId: '',
        userId: ''
      },
      //域名 
      httpUrl: 'https://laravel.gongshicloud.com/api'
    }
  },
  created() {
    //分享
    if (JSON.parse(localStorage.getItem("Sharing"))) {
      this.Sharing = JSON.parse(localStorage.getItem("Sharing"))
    }
  },
  mounted() {
    this.getWXImge()
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (this.$route.query.code != undefined && this.$route.query.code != null && this.$route.query.code != '') {
          localStorage.setItem("code", this.$route.query.code);  //判断是否要进入绑定手机号页面
          this.getWX(this.$route.query.code)
        }
      },
      // 深度观察监听 
      deep: true,
      immediate: true
    }
  },
  methods: {
    //获取微信二维码
    getWXImge() {
      const obj = new WxLogin({
        id: "qrcode",
        appid: 'wx8aca29e958e45c20',
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent('http://project.gongshicloud.com'),
        state: "",
        style: "black",
        href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTpub25lfQ0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30="
      });
    },
    //获取conde
    async getWX(code) {
      try {
        const { data: data } = await this.$http.post('wechat/scan', {
          code,
          state: 'GETCODE',
          team_id: this.Sharing.teamId,
          project_id: this.Sharing.projectId,
          invite_id: this.Sharing.userId,
        })
        if (data.data.access_token != '' && data.data.access_token != undefined && data.data.access_token != null) {
          //存在token直接登录 
          localStorage.setItem("token", data.data.access_token);
          if (this.Sharing.teamId == 'share_collection') {
            // this.$router.push('/collection') 
            this.$router.push({
              path: '/collection',
              query: {
                projectId: this.Sharing.projectId,
                userId: this.Sharing.userId,
              }
            })
          } else {
            this.$router.push('/home')
          }
        } else {
          //完善信息 improveInfo   绑定手机号-->完善信息 
          this.$router.push({
            path: '/getPhone',
            query: {
              open_id: data.data.open_id,
            }
          })
        }
      } catch (error) {
        localStorage.removeItem("code");
      }
    },
    // 切换登录 
    tableswitch(index) {
      this.buttonIndex = index
    },
    //忘记密码
    getforgetPwd() {
      this.$router.push('/forgetPwd')
    },
    //注册账号
    getRegistered() {
      this.$router.push('/registered')
    },
    //登录提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getLoing(this.ruleForm)
        } else {
          return false
        }
      })
    },
    //提交接口 
    async getLoing(user) {
      const { data: data } = await this.$http.post("login/login", {
        username: user.username,
        password: user.password,
        team_id: this.Sharing.teamId,
        project_id: this.Sharing.projectId,
        invite_id: this.Sharing.userId,
      });
      localStorage.setItem("token", data.data.access_token);
      this.getMe()
      this.$message({
        message: data.message,
        type: 'success'
      });
      localStorage.removeItem("Sharing");
      //如果 teamId ==  share_collection 就是 合集分享进来的
      if (this.Sharing.teamId == 'share_collection') {
        this.$router.replace('/collection')
      } else {
        this.$router.replace('/home')
      }
    },
    async getMe() {
      const { data: data } = await this.$http.post('me')
      localStorage.setItem("userinfo", JSON.stringify(data.data))
    },
  }
}
</script>
<style lang="less" scoped >
.login {
  width: 100%;
  height: 100%;
  background: url(../../assets/image/login/bgc.png) no-repeat center;

  .form-login {
    width: 100%;
    height: 100%;
    padding: 22px 38px;

    .form-login-log {
      width: 228px;
      height: 65px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .form-login-center {
      width: 1120px;
      height: 645px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.16);
      display: flex;

      // 左侧登录
      .form-login-mask {
        width: 485px;
        height: 645px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      // 右侧登录
      .form-login-content {
        position: relative;
        flex: 1;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .form-login-top-bgc {
          position: absolute;
          top: 0;
          right: 0;
          width: 82px;
          height: 50px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .class-login {
          margin-top: 100px;
          display: flex;

          .button-list {
            padding: 10px 20px;
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            border: 1px solid #dcdfe6;
            font-size: 13px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            &:hover {
              color: #484c7f;
            }
          }

          .button-active {
            background-color: #484c7f;
            border: 1px solid #484c7f;
            color: #ffffff;

            &:hover {
              color: #fff;
            }
          }

          .button-list:first-child {
            border-radius: 4px 0 0 4px;
          }

          .button-list:last-child {
            border-radius: 0 4px 4px 0;
          }
        }

        .wx-login {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          #qrcode {
            margin-top: 55px;
          }

          .hashCode {
            width: 175px;
            height: 175px;
            margin: 65px 0 18px 0;
            border: 1px solid #dbdbdb;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .hashCode-text {
            width: 120px;
            font-size: 13px;
            color: #212529;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    }

    .account {
      width: 315px;

      .phone-password {
        margin-top: 55px;

        .remember-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 13px;
          color: #484c7f;
          cursor: pointer;
          margin-top: 20px;
        }

        .submit {
          margin-top: 55px;
        }

        .add-password {
          margin-top: 40px;
        }
      }

      //修改 ement 样式
      & /deep/ .el-form-item {
        margin-bottom: 5px;
      }

      & /deep/ .el-form-item__label {
        line-height: 0 !important;
      }

      & /deep/ .el-form-item__content .el-input .el-input__inner {
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        border-radius: 0px;
        padding: 0;
      }

      .registered {
        text-align: right;
        color: #484c7f;
        font-size: 13px;
        margin-top: 15px;
        cursor: pointer;
      }
    }

    .form-login-text {
      position: absolute;
      top: 87.3%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: #909399;
    }
  }

  .buttom-img {
    position: absolute;
    left: 0;
    bottom: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>


